import React, { Component } from 'react';

class LeaderBoard extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {

        return (

            <div className="leaderboard-wrapper">
                <div className="heading-wrap animated bounce">
                    <div className="main-heading-title">
                        <span className="heading-number">4</span>
                        Take Over the Leaderboard
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 select-sport-info">
                        <div className="sub-item-wrapper">
                            {/* <div className="subheading"><span className="subheading-number">4.1</span>HEADING</div> */}
                            <div className="info-description">Earn fame and fortune by climbing to the top of the leaderboards. With the social features in the works it will be easy to challenge your friends or complete
strangers. Since ETH can be won as well as earned there will be seperate boards for each as well
as various other accomplishments.</div>
                        </div>
                        {/* <div className="sub-item-wrapper">
                            <div className="subheading"><span className="subheading-number">4.2</span>HEADING</div>
                            <div className="info-description">Lorem ipsum dolor sit amet, consectetuer adipisc
                            ing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. 
                            Ut wisi enim ad minim veniam, quis nostrud exerci. </div>
                        </div> */}
                    </div>
                    <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 select-sport-grid-wrap">

                <div className="leaderboard">
                    <div>
                        <div className="col" style={{ fontSize: '12px', textAlign: 'left', marginBottom: '40px', padding: '0px', color: 'rgb(109, 218, 255)' }}>
                            <img src="img/icons/trophyIcon.png" style={{ marginRight: '10px', marginBottom: '3px' }} />YOU ARE CURRENTLY RANKED #45 ON THE LEADERBOARD
                        </div>
                    </div>
                    <div className="row leaderboard-titles">
                        <div className="col-2" style={{textAlign:'center'}}>
                            RANK
                        </div>
                        <div className="col-5">
                            USERNAME
                        </div>
                        <div className="col-2">
                            BETS WON
                            </div>
                        <div className="col-3">
                            MVU EARNED
                            </div>
                    </div>
                    <div className="row leaderboard-gold" onClick={this.handleClickEvent}>
                        <div className="col-2" style={{ color: '#ffd200', borderRight: '1px solid #3a4e53', textAlign:'center' }}>
                            <img src="img/icons/goldTrophy.png" style={{ width: '16px' }} />
                        </div>
                        <div className="col-5" style={{ color: '#ffd200', borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Buzz1man.png"/>
                        <img src="img/icons/crown.png" style={{ width: '19px', marginRight: '5px', marginTop: '-4px' }} />
                         Buzz1man
                        </div>
                        <div className="col-2" style={{ color: '#ffd200', borderRight: '1px solid #3a4e53' }}>
                            120
                        </div>
                        <div className="col-3" style={{ color: '#ffd200' }}>
                            1,200 MVU
                        </div>
                    </div>

                    <div className="row" style={{ height: '1px', padding: '0px' }}>
                        <div className="col" style={{ width: '100%', backgroundColor: '#ffd200' }}>
                        </div>
                    </div>
                    <div className="row leaderboard-silver" onClick={this.handleClickEvent}>

                        <div className="col-2" style={{ color: '#c6c6c6', borderRight: '1px solid #3a4e53', textAlign:'center'  }}>
                            <img src="img/icons/silverTrophy.png" style={{ width: '14px' }} />
                            
                        </div>
                        <div className="col-5" style={{ color: '#c6c6c6', borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/ExecMega.png"/>
                            <img src="img/icons/tiara.png" style={{ width: '24px', marginRight: '5px' }} />ExecMega
                        </div>
                        <div className="col-2" style={{ color: '#c6c6c6', borderRight: '1px solid #3a4e53' }}>
                            111
                        </div>
                        <div className="col-3" style={{ color: '#c6c6c6' }}>
                            1,100 MVU
                        </div>

                    </div>
                    <div className="row" style={{ height: '1px', padding: '0px' }}>
                        <div className="col" style={{ width: '100%', backgroundColor: '#c6c6c6' }}>
                        </div>
                    </div>
                    <div className="row leaderboard-bronze" onClick={this.handleClickEvent}>

                        <div className="col-2" style={{ color: '#b6954e', borderRight: '1px solid #3a4e53', textAlign:'center'  }}>
                            <img src="img/icons/bronzeTrophy.png" style={{ width: '11px' }} />
                        </div>
                        <div className="col-5" style={{ color: '#b6954e', borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Quannams.png" width="30" />
                            <img src="img/icons/laurel.png" style={{ width: '24px' }} />Quannams
                        </div>
                        <div className="col-2" style={{ color: '#b6954e', borderRight: '1px solid #3a4e53' }}>
                            104
                        </div>
                        <div className="col-3" style={{ color: '#b6954e' }}>
                            1,000 MVU
                        </div>
                    </div>
                    <div className="row" style={{ height: '1px', padding: '0px' }}>
                        <div className="col" style={{ width: '100%', backgroundColor: '#b6954e' }}>
                        </div>
                    </div>
                    <div className="row" onClick={this.handleClickEvent}>
                        <div className="col-2" style={{ borderRight: '1px solid #3a4e53', textAlign:'center'  }}>
                            4
                    </div>
                        <div className="col-5" style={{ borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Vivalaveca91.png"/>Vivalaveca91
                        </div>
                        <div className="col-2" style={{ borderRight: '1px solid #3a4e53' }}>
                            99
                        </div>
                        <div className="col-3">
                            999 MVU
                        </div>
                    </div>


                    <div className="row" onClick={this.handleClickEvent}>
                        <div className="col-2" style={{ borderRight: '1px solid #3a4e53', textAlign:'center'  }}>
                            5
    
                        </div>
                        <div className="col-5" style={{ borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Forboxylet.svg"/>
                        Forboxylet
                        </div>
                        <div className="col-2" style={{ borderRight: '1px solid #3a4e53' }}>
                            95
                        </div>
                        <div className="col-3">
                            954 MVU
                        </div>
                    </div>



                    <div className="row" onClick={this.handleClickEvent}>
                        <div className="col-2" style={{ borderRight: '1px solid #3a4e53', textAlign:'center'  }}>
                            6
    
                            </div>
                        <div className="col-5" style={{ borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/vividpop.png"/>
                        VividPop
                        </div>
                        <div className="col-2" style={{ borderRight: '1px solid #3a4e53' }}>
                            91
                        </div>
                        <div className="col-3">
                            930 MVU
                        </div>
                    </div>



                    <div className="row" onClick={this.handleClickEvent}>
                        <div className="col-2" style={{ borderRight: '1px solid #3a4e53', textAlign:'center'  }}>
                            7
    
                        </div>
                        <div className="col-5" style={{ borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Stevelson.png"/>
                          Stevelson
                        </div>
                        <div className="col-2" style={{ borderRight: '1px solid #3a4e53' }}>
                            87
                        </div>
                        <div className="col-3">
                            910 MVU
                        </div>
                    </div>
                    <div className="row" onClick={this.handleClickEvent}>
                        <div className="col-2" style={{ borderRight: '1px solid #3a4e53', textAlign:'center'  }}>
                            8
                        </div>
                        <div className="col-5" style={{ borderRight: '1px solid #3a4e53' }}>
                        <img className="leaderboard-avatar-img" src="img/avatars/Luckytone.png"/>
                        Luckytone
                        </div>
                        <div className="col-2" style={{ borderRight: '1px solid #3a4e53' }}>
                            84
                        </div>
                        <div className="col-3">
                            899 MVU
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
            
        );
    }
}

export default LeaderBoard;



// WEBPACK FOOTER //
// ./src/Components/Leaderboard.js